// extracted by mini-css-extract-plugin
export var chevron = "_kg-4";
export var chevronExpanded = "_kg-5";
export var row = "_kg-0";
export var rowBody = "_kg-6";
export var rowDescription = "_kg-7";
export var rowHeader = "_kg-1";
export var rowTitle = "_kg-2";
export var rowTitleComplete = "_kg-3";